import clsx from 'clsx';
import React, { ReactElement } from 'react';

import { Button } from '@/components/button/button';
import { MultiStepModal, MultiStepModalProps, MultiStepModalState } from '@/components/multiStepModal/multiStepModal';
import { Heading } from '@/components/typography/heading';


const STEP_CONSTS = {
  CREATE: 'CREATE'
} as const;

const INPUT_CONSTS = {
  // create
  DESCRIPTION: 'Description',
  NAME: 'Name'
} as const;

export type ModalLowCodeAgentCreateRet = {
  description: string;
  name: string;
};

type Props = {} & MultiStepModalProps<ModalLowCodeAgentCreateRet>;

type State = ModalLowCodeAgentCreateRet & MultiStepModalState<typeof STEP_CONSTS, typeof INPUT_CONSTS>;

export default class ModalLowCodeAgentCreate extends MultiStepModal<Props, State, typeof STEP_CONSTS, typeof INPUT_CONSTS, ModalLowCodeAgentCreateRet> {
  INPUT_CONSTS = INPUT_CONSTS;
  STEP_CONSTS = STEP_CONSTS;

  inputsByStep = {
    [ this.STEP_CONSTS.CREATE ]: {
      [ INPUT_CONSTS.NAME ]: {
        validate: () => !this.state.name
      }
    }
  };

  state: State & MultiStepModalState<typeof STEP_CONSTS, typeof INPUT_CONSTS> = {
    step: this.STEP_CONSTS.CREATE,
    steps: [ this.STEP_CONSTS.CREATE ],
    validationErrKeys: [],
    description: '',
    name: ''
  };

  stepper(): ReactElement {
    const stepMap: Record<string, () => ReactElement> = {
      [ this.STEP_CONSTS.CREATE ]: this.renderStepCreate
    };

    return stepMap[ this.state.step ]();
  }

  onComplete = (): void => {
    const {
      cb
    } = this.props;

    const {
      description,
      name
    } = this.state;

    const ret: ModalLowCodeAgentCreateRet = {
      name,
      description
    };

    cb( ret );
  };

  renderStepCreate = (): ReactElement => {
    const { onClose } = this.props;
    const {
      description,
      name,
      validationErrKeys
    } = this.state;

    return (
      <>
        <Heading as="h2" size="md">
          Create New Agent
        </Heading>
        <div className={ clsx( 'layout__col', 'pad' ) }>
          <label className={ clsx( 'auth_flow_label', this.inputRequiredCheck( this.INPUT_CONSTS.NAME ) ) } htmlFor={ this.INPUT_CONSTS.NAME }>{ this.INPUT_CONSTS.NAME }</label>
          <input
            className={ clsx( 'auth_flow_input' ) }
            defaultValue={ name }
            id={ this.INPUT_CONSTS.NAME }
            name={ this.INPUT_CONSTS.NAME }
            onChange={ e => {
              this.setState( { name: e.target.value }, () => this.validateInput( this.INPUT_CONSTS.NAME ) );
            } }
            type='text'
          />
        </div>
        <div className={ clsx( 'layout__col', 'pad' ) }>
          <label className={ clsx( 'auth_flow_label', this.inputRequiredCheck( this.INPUT_CONSTS.DESCRIPTION ) ) } htmlFor={ this.INPUT_CONSTS.DESCRIPTION }>{ this.INPUT_CONSTS.DESCRIPTION }</label>
          <input
            className={ clsx( 'auth_flow_input' ) }
            defaultValue={ description }
            id={ this.INPUT_CONSTS.DESCRIPTION }
            name={ this.INPUT_CONSTS.DESCRIPTION }
            onChange={ e => this.setState( { description: e.target.value } ) }
            type='text'
          />
        </div>
        <div className={ clsx( 'layout__row', 'pad', 'flex_right' ) }>
          <Button variant='secondary' size='sm' onClick={ onClose }>Cancel</Button>
          <Button variant='primary' size='sm' onClick={ () => this.step() } type='submit' disabled={ !!validationErrKeys.length }>Create</Button>
        </div>
      </>
    );
  };
}